var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_1364)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_101_1364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5,
    width: 9,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.755859 5.2002H8.60805V18.8002H0.755859V5.2002Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_101_1364)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_101_1364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9629 9.90896H12.2513V14.35H18.417C17.8422 17.1714 15.4387 18.7911 12.2513 18.7911C8.48917 18.7911 5.45855 15.7607 5.45855 11.9988C5.45855 8.23702 8.48917 5.20664 12.2513 5.20664C13.8711 5.20664 15.3342 5.78139 16.4837 6.72183L19.8278 3.37802C17.79 1.60158 15.1774 0.504395 12.2513 0.504395C5.87655 0.504395 0.755859 5.62464 0.755859 11.9988C0.755859 18.3731 5.87655 23.4933 12.2513 23.4933C17.999 23.4933 23.2242 19.3135 23.2242 11.9988C23.2242 11.3196 23.1197 10.5881 22.9629 9.90896Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_101_1364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.289062 18.791V5.20654L8.59375 11.9987L-0.289062 18.791Z",
    fill: "#FBBC05"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_101_1364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.755859 0.496094H23.2242V12.0001H0.755859V0.496094Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_101_1364)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_101_1364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9629 9.90896H12.2513V14.35H18.417C17.8422 17.1714 15.4387 18.7911 12.2513 18.7911C8.48917 18.7911 5.45855 15.7607 5.45855 11.9988C5.45855 8.23702 8.48917 5.20664 12.2513 5.20664C13.8711 5.20664 15.3342 5.78139 16.4837 6.72183L19.8278 3.37802C17.79 1.60158 15.1774 0.504395 12.2513 0.504395C5.87655 0.504395 0.755859 5.62464 0.755859 11.9988C0.755859 18.3731 5.87655 23.4933 12.2513 23.4933C17.999 23.4933 23.2242 19.3135 23.2242 11.9988C23.2242 11.3196 23.1197 10.5881 22.9629 9.90896Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_101_1364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.289062 5.20672L8.59375 11.9989L12.2514 8.81185L24.7918 6.77416V-0.540527H-0.289062V5.20672Z",
    fill: "#EA4335"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_101_1364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.755859 0.496094H23.2242V23.4934H0.755859V0.496094Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_101_1364)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_101_1364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9629 9.90896H12.2513V14.35H18.417C17.8422 17.1714 15.4387 18.7911 12.2513 18.7911C8.48917 18.7911 5.45855 15.7607 5.45855 11.9988C5.45855 8.23702 8.48917 5.20664 12.2513 5.20664C13.8711 5.20664 15.3342 5.78139 16.4837 6.72183L19.8278 3.37802C17.79 1.60158 15.1774 0.504395 12.2513 0.504395C5.87655 0.504395 0.755859 5.62464 0.755859 11.9988C0.755859 18.3731 5.87655 23.4933 12.2513 23.4933C17.999 23.4933 23.2242 19.3135 23.2242 11.9988C23.2242 11.3196 23.1197 10.5881 22.9629 9.90896Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_101_1364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.289062 18.7912L15.3865 6.77416L19.5144 7.29666L24.7918 -0.540527V24.5384H-0.289062V18.7912Z",
    fill: "#34A853"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_101_1364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 18,
    height: 19
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49609 5.2002H23.2242V23.4935H6.49609V5.2002Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_101_1364)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_101_1364",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9629 9.90896H12.2513V14.35H18.417C17.8422 17.1714 15.4387 18.7911 12.2513 18.7911C8.48917 18.7911 5.45855 15.7607 5.45855 11.9988C5.45855 8.23702 8.48917 5.20664 12.2513 5.20664C13.8711 5.20664 15.3342 5.78139 16.4837 6.72183L19.8278 3.37802C17.79 1.60158 15.1774 0.504395 12.2513 0.504395C5.87655 0.504395 0.755859 5.62464 0.755859 11.9988C0.755859 18.3731 5.87655 23.4933 12.2513 23.4933C17.999 23.4933 23.2242 19.3135 23.2242 11.9988C23.2242 11.3196 23.1197 10.5881 22.9629 9.90896Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_101_1364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.792 24.5382L8.59397 11.9987L6.50391 10.4314L24.792 5.20654V24.5382Z",
    fill: "#4285F4"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_1364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.8036c6d2c71e46d74744a8e76fa38525.svg";
export { ForwardRef as ReactComponent };